import React from "react";

export default function TourFilters({
  mobilePanel,
  setMobilePanel,
  searchText,
  setSearchText,
  handleSearch,
  searchResult,
  sortOption,
  handleSortChange,
  sortOptions,
}) {
  return (
    <div className={`filterSidebar ${mobilePanel ? "mobileFilterOpen" : ""}`}>
      <button
        type="button"
        className="mobilePanelClose"
        onClick={() => setMobilePanel(null)}
      >
        ×
      </button>

      {(mobilePanel === "filter" || !mobilePanel) && (
        <form className="sidebarSearch" onSubmit={handleSearch}>
          <h4>Search Tours</h4>
          <input
            type="search"
            placeholder="Search tours..."
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
          />
          <button type="submit">Search</button>
          {searchText && <p className="searchResult">{searchResult}</p>}
        </form>
      )}

      {(mobilePanel === "sort" || !mobilePanel) && (
        <div className="sortSection">
          <h4>Sort By</h4>

          {sortOptions.map((option) => (
            <label key={option.key} className="sortOption">
              <input
                type="radio"
                name="tourSort"
                value={option.key}
                checked={sortOption === option.key}
                onChange={handleSortChange}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}